<template>
  <div class="modal-backdrop">
    <div
      class="modal-container standard-size"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">EDIT GLOBAL OPTIONS</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="1.5"></v-icon>
        </div>
      </div>

      <h3 class="h3">Logo</h3>
      <div class="logoWrapper add--margin-top">
        <button class="button-neutral" @click="showImageModal = true">
          Change logo
        </button>
        <ImageManager
          v-if="showImageModal"
          :isModal="true"
          @changed="onSelectedImage"
          @close="showImageModal = false"
        />
        <img class="iconImageBox" v-bind:src="this.navigationObj.logoPath" />
      </div>
      <!-- EDIT STYLES -->
      <div class="colorWrapper add--margin-top">
        <h3 class="h3 add--margin-bottom">Colors</h3>
        <div v-if="showTextColorPicker" class="colorInnerWrap">
          <chrome-picker v-model="colors[activeColorPicker]" />
          <button class="color-picker-button" v-on:click="closeColorPicker()">
            Select
          </button>
          <button
            class="closeBtn color-picker-button"
            v-on:click="closeColorPicker()"
          >
            Close
          </button>
        </div>
        <div class="color-input-wrapper" @click="showColorPicker('textColor')">
          <GlobalInputTextfield
            label="Text color"
            :inputId="'textColor'"
            v-model="navigationObj.textColor"
            maxlength="7"
          />
          <div
            class="color-indicator"
            :style="{ backgroundColor: navigationObj.textColor }"
          ></div>
        </div>
        <div class="color-input-wrapper" @click="showColorPicker('bgColor')">
          <GlobalInputTextfield
            label="Header color"
            :inputId="'bgColor'"
            v-model="navigationObj.bgColor"
            maxlength="7"
          />
          <div
            class="color-indicator"
            :style="{ backgroundColor: navigationObj.bgColor }"
          ></div>
        </div>
        <div
          class="color-input-wrapper"
          @click="showColorPicker('guestbookBodyColor')"
        >
          <GlobalInputTextfield
            label="Guestbook background color"
            :inputId="'guestbookBodyColor'"
            v-model="navigationObj.guestbookBodyColor"
            maxlength="7"
          />
          <div
            class="color-indicator"
            :style="{ backgroundColor: navigationObj.guestbookBodyColor }"
          ></div>
        </div>
      </div>
      <h3 class="h3 add--margin-bottom">Navigation menu</h3>
      <button class="button-neutral" @click="addNew()">ADD</button>
      <div class="menuItemsWrapper">
        <draggable
          v-model="linksArrayClone"
          @start="drag = true"
          @end="drag = false"
          handle=".outerWrap"
          class="linksArrayWrapper"
          :class="{ applyScrollbar: addScrollbar }"
        >
          <div v-for="(link, key) in linksArrayClone" :key="key">
            <div class="outerWrap">
              <v-icon
                class="menuEditIcon"
                name="arrows-alt-v"
                scale="1.5"
              ></v-icon>
              <span @click="handleDropdown()">
                <GlobalInputDropdown
                  class="dropdownSelector"
                  label="Page link"
                  v-model="link.text"
                  :options="navigationMenu"
                />
              </span>
              <div class="menuEditIcon" v-on:click="deleteLink(key)">
                <v-icon name="times" scale="1.5"></v-icon>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="button-container">
        <button class="button-neutral" @click="btnCancel()">Cancel</button>
        <button class="button-positive" @click="btnUpdate()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import ImageManager from "@/components/MediaPage/MediaImages";
import draggable from "vuedraggable";
import languageCookieMixin from "@/mixins/languageCookieMixin";
import { db } from "@/firebase";
import { Sketch } from "vue-color";
import GlobalInputTextfield from "@/components/GlobalComponents/GlobalInputTextfield";
import GlobalInputDropdown from "@/components/GlobalComponents/GlobalInputDropdown";

export default {
  components: {
    ImageManager,
    "chrome-picker": Sketch,
    draggable,
    GlobalInputTextfield,
    GlobalInputDropdown,
  },
  mixins: [languageCookieMixin],
  data() {
    return {
      linksArrayClone: [],
      selectedLanguage: "",
      showImageModal: false,
      pageForDeletion: null,
      navigationObj: {},
      showTextColorPicker: false,
      activeColorPicker: "",
      addScrollbar: false,
      colors: {
        textColor: {
          hex: "#194d33",
        },
        bgColor: {
          hex: "#194d33",
        },
        guestbookBodyColor: {
          hex: "#194d33",
        },
        pagesTitleColor: {
          hex: "#194d33",
        },
        pagesButtonTextColor: {
          hex: "#194d33",
        },
      },
    };
  },
  computed: {
    navigationMenu() {
      let data = [
        {
          text: "Home",
          textSec: "Home",
          name: "Home",
          value: "Home",
          path: `/${this.$hotelId}`,
        },
      ];
      let dropdownData = JSON.parse(JSON.stringify(this.pagesOverview));
      for (var key in dropdownData) {
        data.push({
          text: dropdownData[key].name,
          name: dropdownData[key].name,
          value: dropdownData[key].name,
          path: dropdownData[key].path,
        });
      }
      data.pop();
      return data;
    },
    secondLanguage() {
      return (
        !this.$isSingleLanguage &&
        this.selectedLanguage === this.$settingsSecondLanguageType
      );
    },
  },
  firebase() {
    return {
      linksObj: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/links/`),
        readyCallback: function (data) {
          if (data.val()) {
            this.linksArrayClone = JSON.parse(JSON.stringify(data.val()));
          }
        },
      },
      pagesOverview: {
        source: db.ref(`pages/${this.$customerId}/${this.$hotelId}/overview/`),
        asObject: true,
      },
      navigation: {
        source: db.ref(`/hotels/${this.$customerId}/${this.$hotelId}/nav`),
        readyCallback: function (data) {
          this.navigationObj = data.val();
        },
      },
    };
  },
  watch: {
    colors: {
      handler() {
        this.navigationObj[this.activeColorPicker] = this.colors[
          this.activeColorPicker
        ].hex;
      },
      deep: true,
    },
  },
  created() {
    if (this.getCookie("secondLanguage")) {
      this.selectedLanguage = this.$settingsSecondLanguageType;
    } else {
      this.selectedLanguage = this.$settingsDefaultLanguageType;
    }
  },
  mounted: function () {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.close();
      }
    });
  },
  destroyed: function () {
    document.removeEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.close();
      }
    });
  },
  methods: {
    handleDropdown() {
      for (let index in this.linksArrayClone) {
        for (let item in this.navigationMenu) {
          if (
            this.linksArrayClone[index].text == this.navigationMenu[item].text
          ) {
            this.linksArrayClone[index].path = this.navigationMenu[item].path;
            this.linksArrayClone[index].value = this.navigationMenu[item].value;
            this.linksArrayClone[index].name = this.navigationMenu[item].name;
          }
        }
      }
    },
    showColorPicker(activeBox) {
      this.showTextColorPicker = true;
      this.activeColorPicker = activeBox;
      this.colors[this.activeColorPicker].hex = this.navigationObj[activeBox];
    },
    closeColorPicker() {
      this.showTextColorPicker = false;
    },
    close() {
      this.$emit("close");
    },
    btnUpdate() {
      // takes the color for the header and text and applies them to the back button for pages
      this.navigationObj.pagesTitleColor = this.navigationObj.bgColor;
      this.navigationObj.pagesButtonTextColor = this.navigationObj.textColor;
      this.close();
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/nav/`).set(this.navigationObj);
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/links/`).set(this.linksArrayClone);
      this.closeColorPicker();
      this.$toastEvents.push({
        type: "positive",
        title: "Success",
        content: "The changes has been saved",
        id: +new Date(),
      });
    },
    btnCancel() {
      this.close();
      this.linksArrayClone = JSON.parse(JSON.stringify(this.linksObj));
    },
    addNew() {
      this.linksArrayClone.push({
        text: "Home",
        textSec: "Home",
        name: "Home",
        value: "Home",
        path: `/${this.$hotelId}`,
      });
      if (this.linksArrayClone.length > 6) {
        this.addScrollbar = true;
      } else {
        this.addScrollbar = false;
      }
    },
    deleteLink(key) {
      this.pageForDeletion = key;
      this.linksArrayClone.splice(this.pageForDeletion, 1);
      if (this.linksArrayClone.length <= 6) {
        this.addScrollbar = false;
      }
    },
    onSelectedImage(imageUrl) {
      this.navigationObj.logoPath = imageUrl;
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.dropdownSelector {
  width: 100%;
}

.menuItemsWrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  margin-top: 16px;
}

.linksArrayWrapper {
  max-height: 400px;
  width: 100%;
  margin-bottom: 20px;
}

.applyScrollbar {
  overflow-y: scroll;
}

.menuEditIcon {
  color: #aaaaaa;
  margin-left: 16px;
  margin-right: 16px;
  cursor: pointer;
}

.outerWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 32px;
  margin-top: 16px;
  height: 64px;
  align-content: center;
  border-bottom: dotted #aaaaaa 2px;
}

.color-input-wrapper {
  position: relative;
}

.input-dropdown {
  margin: 0px;
}

.selectionWrap {
  position: relative;
  width: 40%;
  vertical-align: top;
}

.selectionOuterWrap {
  border: 1px solid #707070;
  border-radius: 5px;
  background-color: #ffffff;
  cursor: pointer;
  width: 100%;
  height: 40px;
  z-index: 99;
}

.selectionInnerWrap {
  float: left;
  margin-top: 9px;
  margin-left: 10px;
}

.hiddenSelection {
  position: absolute;
  border: 1px solid #e8e7e3;
  background-color: white;
  border-top: 0;
  z-index: 20;
  width: 100%;
  max-height: 200px;
  overflow: auto;
}

.selectionLink {
  margin-left: 10px;
  text-align: left;
  padding: 11px 0px;
  cursor: pointer;
}

.selectionLink:hover {
  background-color: #e8e7e3;
}

.toggleIcon {
  position: absolute;
  right: 10px;
  top: 4px;
}

.logoWrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.iconImageBox {
  display: flex;
  padding: 10px;
  height: 100px;
  max-width: 300px;
  object-fit: cover;
  overflow: hidden;
  border: solid 2px #aaaaaa;
  border-radius: 8px;
}

.colorInnerWrap {
  position: absolute;
  z-index: 5;
  top: 0px;
  right: 25px;
}

.colorInnerWrap button {
  position: absolute;
  bottom: 5px;
  left: 5px;
  background-color: #48b9ba;
  color: #fff;
  cursor: pointer;
  width: 70px;
  height: 25px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  transition: 0.1s ease-in;
}
.colorInnerWrap button:hover {
  background-color: #49a39c;
}
.colorInnerWrap button.closeBtn {
  left: 85px;
  background-color: #894e99;
}
.color-picker-button {
  padding: 0;
  min-width: 0;
}

.color-indicator {
  width: 28px;
  height: 28px;
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  border-radius: var(--border-radius);
  border: 2px solid var(--grey);
}
</style>
